var _path;

import * as React from "react";

function SvgEnterButton(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.09 4H8.896A4.924 4.924 0 004 8.91v22.194A4.91 4.91 0 008.91 36h22.18A4.91 4.91 0 0036 31.104V8.91A4.924 4.924 0 0031.09 4zm-2.963 18.68a.691.691 0 01-.677.678H14.187l2.526 2.526a.677.677 0 01-.48 1.157.705.705 0 01-.466-.226L12.1 23.146a.692.692 0 01-.155-.225.635.635 0 010-.508.579.579 0 01.155-.226l3.668-3.683a.677.677 0 01.974 0 .72.72 0 010 .974l-2.554 2.511h12.6v-7.633h-5.729a.677.677 0 01-.677-.677.691.691 0 01.677-.734h6.406c.37.008.67.307.677.678l-.014 9.058z"
  })));
}

export default SvgEnterButton;